import { ocapiV1Routes } from '../routes';
export const browsingApiRoutes = {
    availability: {
        films: {
            getAll: ()=>`${ocapiV1Routes.films}/availability`
            ,
            getForFilm: (filmId)=>`${ocapiV1Routes.films}/${filmId}/availability`
            ,
            getForSite: (siteId)=>`${ocapiV1Routes.sites}/${siteId}/films/availability`
        }
    },
    masterData: {
        events: {
            getAll: ()=>ocapiV1Routes.events
            ,
            getById: (eventId)=>`${ocapiV1Routes.events}/${eventId}`
            ,
            getShowtimes: (eventId)=>`${ocapiV1Routes.events}/${eventId}/showtimes`
        },
        films: {
            getAll: ()=>ocapiV1Routes.films
            ,
            getForSite: (siteId)=>`${ocapiV1Routes.sites}/${siteId}/films`
            ,
            getById: (filmId)=>`${ocapiV1Routes.films}/${filmId}`
        },
        filmScreeningDates: {
            getAll: ()=>`${ocapiV1Routes.prefix}/film-screening-dates`
        },
        showtimes: {
            getForFirstBusinessDate: ()=>`${ocapiV1Routes.showtimes}/by-business-date/first`
            ,
            getForBusinessDate: (businessDate)=>`${ocapiV1Routes.showtimes}/by-business-date/${businessDate}`
            ,
            getById: (showtimeId)=>`${ocapiV1Routes.showtimes}/${showtimeId}`
        },
        sites: {
            getAll: ()=>ocapiV1Routes.sites
            ,
            getById: (siteId)=>`${ocapiV1Routes.sites}/${siteId}`
        }
    }
};

//# sourceMappingURL=routes.js.map